export default __webpack_public_path__ + "static/media/Explore-1-mini.e843f972.png";